import { render, staticRenderFns } from "./adminConfig.vue?vue&type=template&id=42135e66&scoped=true"
import script from "./adminConfig.vue?vue&type=script&lang=js"
export * from "./adminConfig.vue?vue&type=script&lang=js"
import style0 from "./adminConfig.vue?vue&type=style&index=0&id=42135e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42135e66",
  null
  
)

export default component.exports